import { createContext } from "react";

const LeadsContext = createContext("leads");
export default LeadsContext;